import { render, staticRenderFns } from "./OldTag.vue?vue&type=template&id=2c62f97a&scoped=true"
import script from "./OldTag.vue?vue&type=script&lang=js"
export * from "./OldTag.vue?vue&type=script&lang=js"
import style0 from "./OldTag.vue?vue&type=style&index=0&id=2c62f97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62f97a",
  null
  
)

export default component.exports